// extracted by mini-css-extract-plugin
module.exports = {"companyAndRole":"company-and-role_companyAndRole__1D5WA","title":"company-and-role_title__qLrg7","rotateColor":"company-and-role_rotateColor__2Ws7_"};